module.exports = __webpack_public_path__ + "static/img/shop6.f95e9e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shop6.png
// module id = 3ryU
// module chunks = 2